import React from 'react'
import { Box, Button, Dialog, Divider, IconButton, Stack, TextField, Typography } from '@mui/material'
import { Add, Close, Save, Delete } from '@mui/icons-material'
import { TranslateContext } from '../../context/TranslateContext'
import { GlobalContext } from '../../context/GlobalContext'
import moment from 'moment'

const FaqComp = () => {
    const L = React.useContext(TranslateContext)
    const [state, setState] = React.useState({
        dialog: false
    })
    const [data, setData] = React.useState("")
    const G = React.useContext(GlobalContext)
    const [testi, setTesti] = React.useState({})

    async function addNew() {
        const data = await G.hitAxios({
            path: "/api/admin/add-faq",
            admin: true,
            post: true,
            obj: testi
        })
        if (data.data.success) {
            setState({ ...state, dialog: false })
            setTesti({})
            getData()
        }
    }

    React.useEffect(() => {
        getData()
    }, [])

    async function delOne(e) {
        if (window.confirm("Are you sure?")) {
            const data = await G.hitAxios({
                path: "/api/admin/del-faq",
                post: true,
                admin: true,
                obj: { id: e }
            })
            getData()
        }
    }

    async function getData() {
        const data = await G.hitAxios({
            path: "/api/admin/get-all-faq",
            post: false,
            admin: false
        })
        setData(data.data.data)
    }

    return (
        <div>
            <Dialog open={state.dialog} onClose={() => setState({ ...state, dialog: false })} fullWidth PaperProps={{
                style: {
                    borderRadius: 10
                }
            }} >
                <Stack direction={'row'} justifyContent={'space-between'} spacing={2} alignItems={'center'} p={2}>
                    <IconButton onClick={() => setState({ ...state, dialog: false })} >
                        <Close />
                    </IconButton>
                    <Typography>{L.data.addFaq}</Typography>
                </Stack>
                <Divider />

                <Box p={2} >
                    <Stack direction={'column'} spacing={2}>
                        <TextField value={testi.que} onChange={(e) => setTesti({ ...testi, que: e.target.value })} label={L.data.que} fullWidth size='small' InputProps={{
                            style: {
                                borderRadius: 10
                            }
                        }} />


                        <TextField value={testi.ans} onChange={(e) => setTesti({ ...testi, ans: e.target.value })} label={L.data.ans} multiline rows={3} fullWidth size='small' InputProps={{
                            style: {
                                borderRadius: 10
                            }
                        }} />

                        <Button
                            onClick={addNew}
                            disabled={testi.que && testi.ans ? false : true}
                            startIcon={<Save />} variant="contained" size='small' sx={{ borderRadius: 2, boxShadow: 0 }} >{L.data.submit}</Button>
                    </Stack>
                </Box>

            </Dialog>

            <Box mt={4}>
                <Stack alignItems='center' spacing={2} direction={'row'} justifyContent='space-between'>
                    <Typography variant='h5' fontWeight={'bold'}>{L.data.manageFaq}</Typography>
                    <Button onClick={() => setState({ ...state, dialog: true })} startIcon={<Add />} sx={{ textTransform: "none", boxShadow: 0, borderRadius: 2 }} variant="contained" >{L.data.addNew}</Button>
                </Stack>

                <Box mt={4}>
                    {data &&
                        <Stack direction={'column'} spacing={2}>
                            {data.map((i, key) => {
                                return (
                                    <Box key={key} borderRadius={4} p={3} sx={{ background: "linear-gradient(90deg, rgba(203, 16, 224, 0.1951374299719888) 0%, rgba(40, 50, 157, 0.29037552521008403) 50%, rgba(35, 189, 196, 0.49037552521008403) 100%)" }}>
                                        <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={2}>
                                            <Stack direction={'column'}>
                                                <Typography fontWeight={'bold'} >{i.que.length > 19 ? i.que.slice(0, 20) + "..." : i.que}</Typography>
                                                <Typography color='gray' variant='caption'>{moment(i.createdAt).format("DD/MM/YY")}</Typography>
                                            </Stack>
                                            <IconButton onClick={() => delOne(i.id)} >
                                                <Delete color='error' />
                                            </IconButton>
                                        </Stack>
                                    </Box>
                                )
                            })}
                        </Stack>}
                </Box>
            </Box>
        </div>
    )
}

export default FaqComp